import React, { useEffect } from 'react';
import { useEditorStore } from './hooks/useEditorStore';
import ModelCanvas from './components/ModelCanvas';
import FileUpload from './components/FileUpload';
import Editor from './components/Editor';
import './App.css';

function App() {
  const {
    uploadedFile,
    backendFilename,
    editedModelUrl,
    originalModelUrl,
    loading,
    error,
    successMessage,
    clearError,
    clearSuccess,
  } = useEditorStore();

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => clearError(), 5000);
      return () => clearTimeout(timer);
    }
  }, [error, clearError]);

  useEffect(() => {
    if (successMessage) {
      const timer = setTimeout(() => clearSuccess(), 5000);
      return () => clearTimeout(timer);
    }
  }, [successMessage, clearSuccess]);

  // Create object URL from uploaded file for preview
  // For GLTF files, we need to use the backend static URL since they reference external .bin files
  // For GLB files, we can use blob URLs for immediate preview
  const previewUrl = backendFilename
    ? uploadedFile?.name?.toLowerCase().endsWith('.gltf')
      ? `http://localhost:5000/uploads/${backendFilename}`
      : URL.createObjectURL(uploadedFile)
    : originalModelUrl;

  return (
    <div className="app">
      <header className="header">
        <h1>🎨 AI 3D Model Editor</h1>
        <p>Upload a model • Enter a prompt • Get instant 3D edits</p>
      </header>

      <div className="container">
        {/* Left Panel: Controls */}
        <div className="left-panel">
          <div className="panel-section">
            <FileUpload />
          </div>

          {uploadedFile && (
            <div className="panel-section">
              <Editor />
            </div>
          )}

          {/* Status Messages */}
          {error && <div className="message error">{error}</div>}
          {successMessage && <div className="message success">{successMessage}</div>}
          {loading && <div className="message info">Processing...</div>}
        </div>

        {/* Right Panel: 3D Viewer */}
        <div className="right-panel">
          <div className="viewer-container">
            <ModelCanvas modelPath={editedModelUrl || previewUrl} />
          </div>
          {uploadedFile && (
            <div className="viewer-info">
              <p>📄 {uploadedFile.name}</p>
              <p>Size: {(uploadedFile.size / 1024 / 1024).toFixed(2)} MB</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default App;
